import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Button, Collapse } from "reactstrap";
import local from "../../localization/strings";

const sections = [
	{ heading: local.TF_SmsExplainerBillingHeading, body: local.TF_SmsExplainerBillingBody },
	{ heading: local.TF_SmsExplainerSendsHeading, body: local.TF_SmsExplainerSendsBody },
	{ heading: local.TF_SmsExplainerRecipientsHeading, body: local.TF_SmsExplainerRecipientsBody },
	{ heading: local.TF_SmsExplainerGatesHeading, body: local.TF_SmsExplainerGatesBody },
	{ heading: local.TF_SmsExplainerSimHeading, body: local.TF_SmsExplainerSimBody },
];

// Explains what the segments on this screen actually buy.
//
// The summary line stays visible because the confusion it clears up — cloud SMS billed through Twilio
// against these packages, versus a logger texting from its own SIM, which nothing here governs — is the
// one that makes people read the numbers as the wrong thing entirely. The rest is a click away so the
// limit field and the package table stay at the top of the dialog.
const SiteSmsExplainer = () => {
	const [expanded, setExpanded] = useState(false);

	return (
		<Alert color="info" className="mb-3">
			<div className="d-flex">
				<FontAwesomeIcon icon="info-circle" className="mt-1 mr-2" fixedWidth />
				<div>
					<div>{local.TF_SmsExplainerSummary}</div>
					<Button color="link" className="p-0 mt-1" onClick={() => setExpanded(!expanded)} aria-expanded={expanded}>
						{expanded ? local.TF_SmsExplainerHide : local.TF_SmsExplainerShow}
					</Button>
					<Collapse isOpen={expanded}>
						<dl className="mb-0 mt-2">
							{sections.map((section) => (
								<div key={section.heading} className="mb-2">
									<dt>{section.heading}</dt>
									<dd className="mb-0">{section.body}</dd>
								</div>
							))}
						</dl>
					</Collapse>
				</div>
			</div>
		</Alert>
	);
};

export default SiteSmsExplainer;
